import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Toaster, toast } from "react-hot-toast";
import { Result, Button } from "antd";
import uniqid from "uniqid";
import { Server } from "App";
import DataPrivacyModal from "Components/Modals/DataPrivacyModal";
const UpdateProfile = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState("");
  const [loader, setLoader] = useState(false);
  const [tokenDetails, setTokenDetails] = useState({});
  const [selectedFile, SetSelectedFile] = useState(null);
  const [completed, setCompleted] = useState(false);
  const [completedText, setCompletedText] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [country, setCountry] = useState("Canada");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [primaryIndustry, setPrimaryIndustry] = useState("");
  const [countryData, SetCountryData] = useState([]);
  const [cityData, SetCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [industryData, SetIndustryData] = useState([]);
  const [errors, setErrors] = useState({});
  const [showDataPrivacyModal, setShowDataPrivacyModal] = useState(false);
  const [dataPrivacyAccepted, setDataPrivacyAccepted] = useState(false);

  useEffect(() => {
    const decodedToken = jwtDecode(token);
    setTokenDetails(decodedToken);
    // console.log(decodedToken);
    setRole(decodedToken.role);
    setUserId(decodedToken.userId);
  }, []);
  const [countdown, setCountdown] = useState(7); // Initial countdown time

  // console.log(tokenDetails, role);
  const filesizes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  const InputChange = (e) => {
    // --For Multiple File Input
    setErrors({ resume: "" });
    let images = [];
    for (let i = 0; i < e.target.files.length; i++) {
      images.push(e.target.files[i]);
      let reader = new FileReader();
      let file = e.target.files[i];
      reader.onloadend = () => {
        SetSelectedFile(() => {
          return [
            {
              id: uniqid(),
              file: file,
              filename: e.target.files[i].name,
              fileimage: reader.result,
              datetime:
                e.target.files[i].lastModifiedDate.toLocaleString("en-IN"),
              filesize: filesizes(e.target.files[i].size),
            },
          ];
        });
      };
      if (e.target.files[i]) {
        reader.readAsDataURL(file);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);
      if (role === "Candidate") {
        let isValid = true;
        const newErrors = {
          resume: "",
        };
        if (!selectedFile || selectedFile?.length === 0) {
          newErrors.resume = "Resume is mandatory";
          isValid = false;
        }
        if (isValid) {
          const formData = new FormData();
          formData.append("file", selectedFile[0].file);
          // console.log(selectedFile);

          const { data } = await axios.post(
            `${Server}/api/v1/contact/email/submit/resume`,
            formData
          );
          // console.log(data);
          // Extract country from parsed resume data
          const parsedCountry =
            data?.data?.basic_info?.Country?.trim().toLowerCase();

          // Define allowed countries
          const allowedCountries = ["ca", "canada"];

          // If the parsed country is not allowed, show an error and stop submission
          if (!allowedCountries.includes(parsedCountry)) {
            toast.error(
              "You are not allowed to register from another country."
            );
            setLoader(false);
            // setTimeout(() => {
            //   if (role === "Candidate") {
            //     navigate("/");
            //   }
            // }, [2000]);
            return;
          }
          const payload = {
            phone_number: data?.data?.basic_info?.phone_number,
            name: data?.data?.basic_info?.full_name,
            position: data?.data?.basic_info?.Job_Title,
            jobTitle: data?.data?.basic_info?.Job_Title,
            work_experience: data?.data?.work_experience,
            skills: data?.data?.skills,
            country: data?.data?.basic_info?.Country,
            city: data?.data?.basic_info?.City,
            address: `${data?.data?.basic_info?.Province},${data?.data?.basic_info?.Country}`,
            description: `I am a ${data?.data?.basic_info?.Job_Title}`,
            state: data?.data?.basic_info?.Province,
            Education: data?.data?.Education,
            resume: data.location,
            experience: data?.data?.basic_info?.Experience_in_Years,
            isResumeUploaded: true,
            profileCompleted: true,
          };
          // console.log(payload);

          const res = await axios.post(
            `${Server}/api/v1/candidate/update/${userId}`,
            payload
          );
          // console.log(res);

          setLoader(false);

          toast.success("Upload Success");
          SetSelectedFile(null);
          setCompleted(true);
          setCompletedText("Your resume has uploaded sucessfully.");
          let profileCompleted = localStorage.setItem(
            "ProfileCompleted",
            "True"
          );

          const interval = setInterval(() => {
            setCountdown((prev) => {
              if (prev === 1) {
                clearInterval(interval);
                navigate("/candidate-dashboard"); // Redirect when countdown reaches 0
              }
              return prev - 1;
            });
          }, 1000);

          return () => clearInterval(interval); // Cleanup interval on unmount
        } else {
          setErrors(newErrors);
          setLoader(false);
          toast.error("Please Upload Resume");
        }
      } else if (role === "Employer") {
        e.preventDefault();
        let isValid = true;
        const newErrors = {
          companyName: "",
          country: "",
          city: "",
          state: "",
          primaryIndustry: "",
        };
        if (companyName.length === 0) {
          newErrors.companyName = "Company Name Required";
          isValid = false;
        }
        if (country.length === 0) {
          newErrors.country = "Country Required.";
          isValid = false;
        }
        if (state.length === 0) {
          newErrors.state = "State Required.";
          isValid = false;
        }
        if (city.length === 0) {
          newErrors.city = "City Required.";
          isValid = false;
        }
        if (primaryIndustry.length === 0) {
          newErrors.primaryIndustry = "Industry Required.";
          isValid = false;
        }
        if (isValid) {
          let payload = {
            companyName,
            country,
            city,
            state,
            primaryIndustry,
            profileCompleted: true,
          };
          const { data } = await axios.post(
            `${Server}/api/v1/employer/update/${userId}`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setCompleted(true);
          setCompletedText("Your Details has updated sucessfully.");
          let profileCompleted = localStorage.setItem(
            "ProfileCompleted",
            "True"
          );

          const interval = setInterval(() => {
            setCountdown((prev) => {
              if (prev === 1) {
                clearInterval(interval);
                let Subscribed = localStorage.getItem("Subscribed");
                if (Subscribed === "false") {
                  navigate("/pricing"); // Redirect when countdown reaches 0
                } else {
                  navigate("/employer-dashboard"); // Redirect when countdown reaches 0
                }
              }
              return prev - 1;
            });
          }, 1000);

          return () => clearInterval(interval); // Cleanup interval on unmount
        } else {
          setErrors(newErrors);
          setLoader(false);
          toast.error("Please fill required fields");
        }
      }
    } catch (error) {
      // console.log(error);
      setLoader(false);
      toast.error("Internal Server error");
    }
  };
  const fetchCountries = async () => {
    try {
      const { data } = await axios.get(
        `https://countriesnow.space/api/v0.1/countries`
      );
      // console.log(data.country_city);
      SetCountryData(data.data);
    } catch (error) {
      // console.log(error);
    }
  };
  const fetchStates = async () => {
    try {
      const { data } = await axios.post(
        `https://countriesnow.space/api/v0.1/countries/states`,
        {
          country: country,
        }
      );
      setStateData(data.data.states); // Set state data
    } catch (error) {
      // console.log(error);
    }
  };
  useEffect(() => {
    if (country) {
      fetchStates(); // Fetch states when country changes
    }
  }, [country]);
  useEffect(() => {
    if (state) {
      fetchCities(); // Fetch states when country changes
    }
  }, [state]);
  useEffect(() => {
    fetchCountries();
    fetchIndustries();
  }, []);
  const fetchCities = async () => {
    try {
      const { data } = await axios.post(
        `https://countriesnow.space/api/v0.1/countries/state/cities`,
        {
          country: country,
          state: state,
        }
      );
      // console.log(data.country_city);
      SetCityData(data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchIndustries = async () => {
    try {
      const { data } = await axios.get(`${Server}/api/v1/data/industries`);
      // console.log(data.country_city);
      SetIndustryData(data.industries);
    } catch (error) {
      // console.log(error);
    }
  };

  const countryOptions = countryData?.map((e, idx) => ({
    value: e.country,
    label: e.country,
  }));
  const stateOptions = country
    ? stateData?.map((e, idx) => ({
        value: e.name,
        label: e.name,
      }))
    : [{ value: null, label: "Select Country First" }];

  const cityOptions = state
    ? cityData?.map((e, idx) => ({ value: e, label: e }))
    : [{ value: null, label: "Select State First" }];
  return (
    <div className="d-flex vh-100 justify-content-center align-items-center">
      <Toaster position="top-center" reverseOrder={false} />
      {completed ? (
        <Result
          status="success"
          title={completedText}
          subTitle={`Thanks for registering with skillstream.You will be redirect in ${countdown} s`}
          extra={
            <Button
              type="primary"
              onClick={() => {
                if (role === "Candidate") {
                  navigate("/candidate-dashboard");
                } else if (role === "Employer") {
                  let Subscribed = localStorage.getItem("Subscribed");
                  if (Subscribed === "false") {
                    navigate("/pricing"); // Redirect when countdown reaches 0
                  } else {
                    navigate("/employer-dashboard"); // Redirect when countdown reaches 0
                  }
                } else {
                  console.warn("Invalid role:", role); // Optional: Handle unknown roles
                }
              }}
            >
              Go To dashboard
            </Button>
          }
        />
      ) : (
        <div>
          {" "}
          {token ? (
            <div className="card p-4 shadow" style={{ width: "500px" }}>
              <h1
                className="text-center mb-3"
                style={{ color: "black", fontSize: "30px", fontWeight: "700" }}
              >
                {" "}
                Welcome to Skillstream AI
              </h1>
              <h3
                className="text-center mb-3"
                style={{ color: "black", fontWeight: "500" }}
              >
                Thank you for registering with Skill Stream.Updating your
                profile helps job seekers learn more about your company and the
                opportunities you offer.
              </h3>
              <form onSubmit={handleSubmit}>
                {role === "Employer" ? (
                  <div>
                    {" "}
                    <div className="mb-3">
                      <label className="form-label">Company Name</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                          setCompanyName(e.target.value);
                          setErrors((prev) => ({ ...prev, companyName: "" }));
                        }}
                      />
                      {errors.companyName && (
                        <p style={{ color: "red" }}>{errors.companyName}</p>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Industry</label>
                      <select
                        className="form-control"
                        value={primaryIndustry}
                        onChange={(e) => {
                          setPrimaryIndustry(e.target.value);
                          setErrors((prev) => ({
                            ...prev,
                            primaryIndustry: "",
                          }));
                        }}
                      >
                        <option value="">Select Industry</option>
                        {industryData?.map((e, idx) => (
                          <option
                            key={idx}
                            value={typeof e === "object" ? e.id || e.name : e}
                          >
                            {typeof e === "object" ? e.name : e}
                          </option>
                        ))}
                      </select>
                      {errors.primaryIndustry && (
                        <p style={{ color: "red" }}>{errors.primaryIndustry}</p>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Country</label>
                      <select
                        className="form-control"
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value);
                          setErrors((prev) => ({ ...prev, country: "" }));
                        }}
                        disabled
                      >
                        <option value="">Select Country</option>
                        {countryData?.map((e, idx) => (
                          <option key={idx} value={e.country}>
                            {e.country}
                          </option>
                        ))}
                      </select>
                      {errors.country && (
                        <p style={{ color: "red" }}>{errors.country}</p>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">State</label>
                      <select
                        className="form-control"
                        value={state}
                        onChange={(e) => {
                          setState(e.target.value);
                          setErrors((prev) => ({ ...prev, state: "" }));
                        }}
                        disabled={!country} // Disable if no country selected
                      >
                        <option value="">Select State</option>
                        {stateData?.map((e, idx) => (
                          <option key={idx} value={e.name}>
                            {e.name}
                          </option>
                        ))}
                      </select>
                      {errors.state && (
                        <p style={{ color: "red" }}>{errors.state}</p>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">City</label>
                      <select
                        className="form-control"
                        value={city}
                        onChange={(e) => {
                          setCity(e.target.value);
                          setErrors((prev) => ({ ...prev, city: "" }));
                        }}
                        disabled={!state} // Disable if no state selected
                      >
                        <option value="">Select City</option>
                        {cityData?.map((e, idx) => (
                          <option key={idx} value={e}>
                            {e}
                          </option>
                        ))}
                      </select>
                      {errors.city && (
                        <p style={{ color: "red" }}>{errors.city}</p>
                      )}
                    </div>
                  </div>
                ) : role === "Candidate" ? (
                  <div>
                    <div className="mb-3">
                      <label className="form-label">Upload Resume</label>{" "}
                      <input
                        class="uploadButton-input"
                        type="file"
                        name="attachments[]"
                        accept="application/pdf,.doc,.docx"
                        id="upload"
                        onChange={InputChange}
                      />
                      {errors.resume && (
                        <p style={{ color: "red" }}>{errors.resume}</p>
                      )}
                    </div>
                  </div>
                ) : null}

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loader}
                >
                  {loader ? "Submitting Details..." : "Submit"}
                </button>
              </form>
              <DataPrivacyModal
                showDataPrivacyModal={showDataPrivacyModal}
                setShowDataPrivacyModal={setShowDataPrivacyModal}
                handleSubmit={handleSubmit}
              />
            </div>
          ) : (
            <Result
              status="404"
              title="404"
              subTitle="Sorry, the page you visited does not exist."
              extra={
                <Button type="primary" onClick={() => navigate("/")}>
                  Back Home
                </Button>
              }
            />
          )}
        </div>
      )}
    </div>
  );
};

export default UpdateProfile;
